import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import {deleteLocation, fetchLocations, newLocation} from "../api/locationApi";
import { useNavigate } from "react-router-dom";
import DataTable from "../components/DataTable";
import {deleteOffer, newOffer} from "../api/offerapi";

export default function Locations() {
    const { token } = useAuth();
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchData = async (silent = false) => {
        if (!silent) setLoading(true);
        try {
            const res = await fetchLocations();
            if (res?.success) {
                setLocations(res.data);
                setError(null);
            } else {
                setError(res?.message || "Failed to fetch locations");
            }
        } catch (err) {
            console.error("Error fetching locations:", err);
            setError(err.message);
        } finally {
            if (!silent) setLoading(false);
        }
    };


    useEffect(() => {
        fetchData();
    }, [token]);

    async function addRow() {
        const tempLocation = {
            LocationID: "temp-" + Date.now(),
            Name: "Creating new location...",
            expires_at: null,
        };

        // 👇 new offer goes to the top
        setLocations([tempLocation, ...locations]);

        setLoading(true);
        try {
            await newLocation()
            await fetchData(true);
        } catch {
            // if failed, remove the temp one
            setLocations(locations.filter((item)=> item.LocationID !== tempLocation.LocationID));
        } finally {
            setLoading(false);
        }
    }

    async function removeRow(row) {
        const prev = locations;
        // instant local update
        setLocations(locations.filter((item)=> item.LocationID !== row.LocationID));

        setLoading(true);
        try {
            await deleteLocation(row.LocationID);
            await fetchData(true); // silent refresh
        } catch {
            // rollback if failed
            setLocations(prev);
        } finally {
            setLoading(false);
        }
    }

    const handleAdd = () => console.log("Add location");
    const handleRemove = (loc) => console.log("Remove location:", loc);
    const handleRowClick = (loc) => navigate(`/locations/${loc.LocationID}`);

    if (loading) return <p className="m-3">Loading locations...</p>;
    if (error) return <p className="m-3 text-danger">❌ {error}</p>;

    return (
        <div className="container mt-4">
            <DataTable
                title="Locations"
                columns={[
                    { key: "Name", label: "Name", searchable: true },
                    { key: "Coords", label: "Coordinates" },
                ]}
                data={locations}
                add
                remove
                onAdd={addRow}
                onRemove={removeRow}
                onRowClick={handleRowClick}
            />
        </div>
    );
}
